@if ({formattedAlerts: formattedAlerts$ | async, loading: loadingAlerts$ | async}; as state) {
  @if (state.formattedAlerts) {
    <div class="alerts-container">
      @for (alert of state.formattedAlerts; track $index) {
        <div class="alert">
          <oph-icon [name]="'activities/' + alert.icon" class="alert-icon" [size]="16"></oph-icon>
          <div class="alert-text-container">
            <span class="username">{{ alert.name }}</span>
            <span class="time-ago">{{ alert.timeAgo }}</span>
            <br />
            @if (alert.type === 'project') {
              @if (alert.linkable) {
                <button (click)="onLinkClick(alert)" class="link link-mr">{{ alert.linkText }}</button>
              } @else {
                <span class="link-disabled">{{ alert.linkText }}</span>
              }
            }
            @if (alert.type !== 'triggeredTask') {
              <span class="alert-text">{{ alert.text }}</span>
            }
            @if (alert.type === 'task') {
              @if (alert.linkable) {
                <button (click)="onLinkClick(alert)" class="link">{{ alert.linkText }}</button>
              } @else {
                <span class="link-disabled">{{ alert.linkText }}</span>
              }
            }
          </div>
          @if (!alert.dismissed) {
            <div class="unread"></div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="oph-loading-container">
      <oph-loading></oph-loading>
    </div>
  }
}
